// extracted by mini-css-extract-plugin
export default {"serviceCards":"ServiceCard_serviceCards__QmQ2b","serviceCard":"ServiceCard_serviceCard__Y33pv","cardContent":"ServiceCard_cardContent__ewAzA"};